const getCompany = state => state.Company.AddCompanies

const selectors = {
    getCompany,
}

export default selectors